import { calculateVirtualEventStatus } from '@/models/eventModel';
import type { Database } from '@/types/supabase';

type EventRow = Database['public']['Tables']['event']['Row'];

export type WindowVerdict = { open: true } | { open: false; reason: 'registration_closed' };

export function evaluateRegistrationWindow(
  event: Pick<
    EventRow,
    'status' | 'start_date' | 'end_date' | 'registration_opens' | 'registration_closes'
  >,
): WindowVerdict {
  const open =
    event.status === 'published' && calculateVirtualEventStatus(event) === 'registration_open';
  return open ? { open: true } : { open: false, reason: 'registration_closed' };
}
